import { Axios, AxiosService } from '@/services/Axios';
import { ContactVm } from '@/types';
import { clearPhoneNumberFormatting } from '@/utils/format-phone-number';

import { Contact, InputContactInfo } from './types';

export class ShippingAddressControllerClass {
  constructor(private APIService: AxiosService) {}

  createNewShippingAddress = (shippingAddress: ContactVm | InputContactInfo) => {
    const { contactId, ...address } = shippingAddress;

    address.phoneNumber = clearPhoneNumberFormatting(address.phoneNumber);

    return this.APIService.post('/contacts', address);
  };

  fetchShippingAddresses = () => {
    return this.APIService.get('/contacts');
  };

  updateShippingAddresses = (newShipmentInfo: Contact | ContactVm) => {
    const payload = {
      ...newShipmentInfo,
      phoneNumber: clearPhoneNumberFormatting(newShipmentInfo.phoneNumber),
    };

    return this.APIService.put(`/contacts/${newShipmentInfo.contactId}`, payload);
  };

  deleteShippingAddresses = (shipmentAddressId: string) => {
    return this.APIService.delete(`/contacts/${shipmentAddressId}`);
  };
}

export const ShippingAddressController = new ShippingAddressControllerClass(Axios);
